import * as React from 'react';
import * as Classes from '../common/classes';
import classNames from 'classnames';
import { BaseProps } from '../common/props';

type DefaultTabProps = BaseProps & {
  disabled?: boolean;
  active?: boolean;
  onSelect?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
};
export const Tab: React.FC<DefaultTabProps> = ({
  className,
  style,
  children,
  disabled,
  active,
  onSelect,
}) => {
  return (
    <div
      className={classNames(Classes.TAB, className, {
        [Classes.TAB_DISABLED]: disabled,
        [Classes.TAB_ACTIVE]: active,
      })}
      style={style}
      onClick={onSelect && !disabled ? (event) => onSelect(event) : undefined}
    >
      <div className={Classes.TAB_WRAPPER}>{children}</div>
    </div>
  );
};
